import React from "react";

import { useQuery } from "@apollo/client";
import { Box } from "@mui/material";
import { Route, Routes, useParams } from "react-router-dom";
import { withStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { MessageChannel } from "@/gql/graphql";
import Chat from "@/pages/Messages/MessageChat/components/Chat";
import Layout from "@/pages/Messages/MessageChat/components/Layout";

type RouteParams = {
  clientId: string;
};

const Root = withStyles(Box, {
  root: {
    flex: 1,
    paddingTop: 2,
    paddingLeft: 2,
  },
});

const messageSectionQuery = graphql(`
  query ClientChatId($clientId: ID!) {
    client(id: $clientId) {
      id
      chat {
        id
      }
    }
  }
`);

const MessageSection: React.FC = () => {
  const { clientId } = useParams<RouteParams>();
  const { data } = useQuery(messageSectionQuery, {
    variables: { clientId: clientId ?? "" },
  });
  return (
    <Root>
      <Layout chatId={data?.client?.chat.id ?? ""} fromProfile={true}>
        <Routes>
          <Route
            path={`appointment`}
            element={
              <Chat
                key={`${clientId}_${MessageChannel.Appointment}`}
                chatId={data?.client?.chat.id ?? ""}
                channel={MessageChannel.Appointment}
              />
            }
          />
          <Route
            path={`meal-plan`}
            element={
              <Chat
                key={`${clientId}_${MessageChannel.MealPlan}`}
                chatId={data?.client?.chat.id ?? ""}
                channel={MessageChannel.MealPlan}
              />
            }
          />
          <Route
            path={`progress`}
            element={
              <Chat
                key={`${clientId}_${MessageChannel.Progress}`}
                chatId={data?.client?.chat.id ?? ""}
                channel={MessageChannel.Progress}
              />
            }
          />
          <Route
            path={`questions`}
            element={
              <Chat
                key={`${clientId}_${MessageChannel.Questions}`}
                chatId={data?.client?.chat.id ?? ""}
                channel={MessageChannel.Questions}
              />
            }
          />
        </Routes>
      </Layout>
    </Root>
  );
};

export default MessageSection;
